import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { PageLoader } from "./ui/page-loader";

function RequireAuthWithRole({ role }) {
  const { auth, user, isLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while auth is being loaded from localStorage
  if (isLoading) {
    return <PageLoader fullScreen />;
  }

  const email = auth?.email ?? null;
  const roles = user.roles ?? [];
  if (!email || !roles.includes(role)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <Outlet />;
}

export default RequireAuthWithRole;
